module.exports = __webpack_public_path__ + "static/media/google-sheets-icon.d880494a.svg";